import axios from 'axios';
import Spinner from 'reactstrap/es/Spinner';
import Table from 'reactstrap/es/Table';
import numeral from 'numeral';
import { Alert, Input } from 'reactstrap';
import { parseApiError } from '@yooink/youtils/es/ParseApiError';
import { usePromise } from '../../../Utils/usePromise';
import { UserBadgeById } from '../../Users/components/UserBadgeById';

import 'numeral/locales/ru';

export function BestMedia ({ from, to }) {
	const { isLoading, isError, errData, data = {} } = usePromise(() => axios.get('/api/v2/analytics/general/bestMedia', { params: { from, to } })
			.then((res) => res.data), [from.getTime(), to.getTime()]);
	const { items } = data;
	return (
		<>
			<div>
				<div className="d-flex mb-4 align-items-center">
					<h4 className="mr-3 mb-0">
						Лучшие продажи медиа
					</h4>
					<div className="ml-auto">
						<Input placeholder="Название промокода" />
					</div>
				</div>
				{isLoading && <Spinner />}
				{!isLoading && isError && (
					<Alert color="danger">
						<h3>Произошла ошибка при запросе данных</h3>
						<pre>{parseApiError(errData)}</pre>
					</Alert>
				)}
				{!isLoading && !isError && (
					<Table responsive>
						<thead>
							<tr>
								<th>Пользователь</th>
								<th>Промокод</th>
								<th>Кол-во шт</th>
								<th>Цена</th>
							</tr>
						</thead>
						<tbody>
							{items.map((item) => (
								<tr>
									<th>
										<UserBadgeById userId={item.user._id} compact />
									</th>
									<td>{item.promocode}</td>
									<td>{item.count}</td>
									<td>{numeral(item.totalPrice).format('0,0')} ₽</td>
								</tr>
							))}
						</tbody>
					</Table>
				)}
			</div>
		</>
	);
}
